// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__LV2HF","logo":"footer_logo__ElLXN","borderLeft":"footer_borderLeft__epQBd"};